import { render, staticRenderFns } from "./ScreensaverTable.vue?vue&type=template&id=3e2b2c12"
import script from "./ScreensaverTable.vue?vue&type=script&lang=ts"
export * from "./ScreensaverTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports